export default "__VITE_PUBLIC_ASSET__edd8bca9__"